import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface SystemTool {
  id: number;
  label: string;
  tips?: string;
  path?: string;
  permissions?: string[];
  icon?: string[];
}

@Component({
  selector: 'sbd-doug-frontend-utility-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './utility-card.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtilityCardComponent {
  @Input({ required: true }) tool: SystemTool;
  @Output() cardClicked = new EventEmitter<SystemTool>();

  onClicked(): void {
    this.cardClicked.emit(this.tool);
  }
}
